import { axios } from "@/plugins/axios"
import store from "@/store"
import { app } from "@/main"


export async function getVms() {
  const vmsApi = "/system/vms";
  let vmses = []

  await axios
    .get(vmsApi)
    .catch((error) => {
      if (error.response.data.status == undefined) {
        store.dispatch("openSnackbar", {
          message: app.$t("vmsNetworkError"),
        });
      } else {
        store.dispatch("openSnackbar", {
          message: error.response.data.status.message,
        });
      }
      throw (error)
    })
    .then((response) => {
      if (response.data.vms != undefined) {
        vmses = response.data.vms
      }
    })

  return vmses
}

export async function addVms(data) {
  const vmsApi = "/system/vms";

  await axios
    .post(vmsApi, data)
    .catch((error) => {
      if (error.response.data.status == undefined) {
        store.dispatch("openSnackbar", {
          message: app.$t("vmsNetworkError"),
        });
      } else {
        store.dispatch("openSnackbar", {
          message: error.response.data.status.message,
        });
      }
      throw (error)
    });
}